<h2 class="title" data-test="tlm-confirmation-sheet:title">{{ title() }}</h2>
@if (message(); as text) {
  <p class="message" data-test="tlm-confirmation-sheet:message">{{ text }}</p>
}
<button
  type="button"
  class="confirm"
  data-test="tlm-confirmation-sheet:confirm"
  (click)="confirm()"
>
  {{ confirmLabel() }}
</button>
